import { render, staticRenderFns } from "./T-F-Under-Grad-2022-CN.vue?vue&type=template&id=2c1dfdbd&scoped=true&"
import script from "./T-F-Under-Grad-2022-CN.vue?vue&type=script&lang=js&"
export * from "./T-F-Under-Grad-2022-CN.vue?vue&type=script&lang=js&"
import style0 from "./T-F-Under-Grad-2022-CN.vue?vue&type=style&index=0&id=2c1dfdbd&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1dfdbd",
  null
  
)

export default component.exports